import { render, staticRenderFns } from "./activeUser.vue?vue&type=template&id=f6f98994&scoped=true&"
import script from "./activeUser.vue?vue&type=script&lang=js&"
export * from "./activeUser.vue?vue&type=script&lang=js&"
import style0 from "./activeUser.vue?vue&type=style&index=0&id=f6f98994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f98994",
  null
  
)

export default component.exports